import React, { useState } from "react";
import { useAuth } from "./context/AuthContext.js";
import { Link, useNavigate } from "react-router-dom";
import { getApiBase } from "./backendProbe.js";
import GoogleContinueButton from "./components/GoogleContinueButton.js";
import "./LoginPage.css";

export default function UnifiedAuthPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleGoogleLogin = (credentialResponse) => {
    const base = getApiBase();
    const endpoint = base ? `${base}/auth/google` : "/auth/google";
    setIsLoading(true);
    setError("");
    fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token: credentialResponse.credential }),
    })
      .then(async (res) => {
        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
          const msg =
            data?.message ||
            (res.status === 401 ? "Invalid Google token (check backend GOOGLE_CLIENT_ID matches this site)." : `Request failed (${res.status})`);
          throw new Error(msg);
        }
        if (!data?.token) throw new Error(data?.message || "Google login failed.");
        login(data.token, data.user);
        navigate("/chatbot", { replace: true });
      })
      .catch((e) => {
        setError(e?.message || "Google login failed. Please try again.");
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <div className="auth-container">
      <a href="#auth-title" className="login-skip">
        Skip to sign in
      </a>
      <div className="login-atmosphere" aria-hidden="true">
        <span className="login-orb login-orb--teal" />
        <span className="login-orb login-orb--violet" />
        <span className="login-orb login-orb--mist" />
        <span className="login-grain" />
      </div>
      <Link to="/" className="login-top-brand" aria-label="Zolaid home">
        <span className="login-wordmark">Zolaid</span>
      </Link>
      <main className="login-form" aria-labelledby="auth-title" aria-busy={isLoading}>
        <div className="login-header">
          <h1 id="auth-title" className="login-title">Sign in</h1>
          <p className="login-subtitle">Continue with your account to start creating on ZOLAID.</p>
        </div>

        {error ? (
          <p className="error-message" role="alert">
            {error}
          </p>
        ) : null}

      <div className="oauth-stack" role="group" aria-label="Continue with Google">
        <GoogleContinueButton
          disabled={isLoading}
          onSuccess={handleGoogleLogin}
          onError={() => setError("Google login was cancelled or failed.")}
        />
      </div>

      <p className="login-legal">
        By continuing, you agree to our <Link to="/TermsOfService">Terms of Service</Link>{" "}
        and have read our <Link to="/PrivacyPolicy">Privacy Policy</Link>.
      </p>
      </main>
    </div>
  );
}
